import React from 'react';

import * as S from './ReviewRatingStyle';

const ReviewRatingUI = ({
    margin = "",
    data
}) => {
    const { review_str = '', review = {}, bar_list = []  } = data;

    return (
        <S.RatingContainer>
            <S.RatingCont margin={margin}>
                {!!review?.t && <div className={`RatingCont__left`} style={{ backgroundColor: review?.bc || "#1b9564"  }}>
                    <span className="rating"><span>{review?.t}/</span><span>5</span></span>
                    {/* <span className="reviewText">{totalReview} Reviews</span> */}
                    {/* <span className="reviewText">{totalRating} Ratings</span> */}
                </div>}
                {review_str && <S.ReviewStr>{review_str}</S.ReviewStr>}
            </S.RatingCont>
            <S.RatingBar>
                {
                    bar_list && bar_list.length > 0 &&
                    <div className="RatingCont__list">
                        {
                            bar_list.map(({ color, fill_area, rating, title }) => (
                                <div className="bars" key={title}>
                                    <div className="ratingText">
                                        <span className="starText">{title}</span>
                                        <span className="reviewCount">{rating}</span>
                                    </div>
                                    {/* <span className="starIcon"></span> */}
                                    <div className="starBar">
                                        <div className={`starBar__progress`} style={{ width: fill_area, backgroundColor: color }}></div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                }
            </S.RatingBar>
        </S.RatingContainer>
    );
};

export default ReviewRatingUI;
